import { Injectable } from '@angular/core';
import { isSupportedLanguageCode, SupportedLanguageCode } from '../../constants/language.constants';

const LANGUAGE_STORAGE_KEY = 'language';

/**
 * Service for reading/writing the user's language preference to localStorage.
 * Handles storage errors gracefully for embedded/iframe contexts.
 */
@Injectable({
  providedIn: 'root',
})
export class LanguagePreferenceService {
  /** Read stored language preference from localStorage, if any and still supported. */
  getStoredPreference(): SupportedLanguageCode | null {
    try {
      const stored = localStorage.getItem(LANGUAGE_STORAGE_KEY);
      return stored && isSupportedLanguageCode(stored) ? stored : null;
    } catch {
      // Storage blocked (e.g., embedded/iframe contexts)
      return null;
    }
  }

  /** Persist language preference to localStorage so it survives a page reload. */
  savePreference(code: SupportedLanguageCode): void {
    try {
      localStorage.setItem(LANGUAGE_STORAGE_KEY, code);
    } catch {
      // Best-effort persistence: ignore storage errors
    }
  }
}
